import { getCurrentRouteParentRoute } from '../../utils/routes';
import { useFirebaseAuth } from '../../../global/FirebaseProvider/FirebaseProvider';
import { isMobile } from '../../../../hooks/useBreakPoint';
import { PackageTrackingPill } from '../PackageTrackingPill';
import TCNavPill from '../TCNavPill/TCNavPill';
import BuyTbbButton from '../BuyTbbButton/BuyTbbButton';
import useUserBalance from '../../utils/hooks/useUserBalance';

const SideNav = () => {
  const { isSignedIn, loading, userData } = useFirebaseAuth();
  const isMobileSize = isMobile();
  const balance = useUserBalance(isSignedIn, userData);

  if (!isSignedIn && !loading) {
    return null;
  }

  if (isMobileSize && getCurrentRouteParentRoute()) {
    return null;
  }

  if (!userData) {
    return null;
  }

  return (
    <>
      <PackageTrackingPill />
      {!isMobileSize && (
        <TCNavPill
          balance={balance !== null ? balance : userData.balance?.currentBalance}
        />
      )}
      {!userData?.activeSubscription && (
        <BuyTbbButton />
      )}
    </>
  );
};

export default SideNav;
